import { getColor } from 'common/constants/_colors';
import { SIZES } from 'common/constants/sizes';
import styled from 'styled-components';

export const StyledDeleteConfirmation = styled.div`
  padding: 2rem;
  & > header {
    display: flex;
    align-items: flex-start;
    font-size: ${SIZES['x-large']};
    color: #000;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
    & svg#Trash {
      position: relative;
      bottom: 0.3rem;
      margin-right: 0.5rem;
    }
  }
  & > main {
    font-size: ${SIZES.medium};
    color: ${getColor('shuttleGray')};
  }
  & > footer {
    margin-top: 3rem;
    display: flex;
    justify-content: flex-end;

    & button {
      margin-left: 1rem;
    }
  }
`;
